import { firestore } from '@/firebase'
import router from '@/router'

const getDefaultState = () => {
  return {
    // 画像関係の設定情報一覧
    // { type: {}, type: {}, ... }
    settingImages: {}
  }
}

const state = getDefaultState()

const getters = {
  /**
   * @param {Object} state 暗黙的に受け取るstate
   * @param {String} type 画像のタイプ
   * @return {Object} 画像の設定情報
   */
  settingImage: state => type => state.settingImages[type] || null
}

const mutations = {
  /**
   * 画像の設定情報をstateにセット
   * @param {Object} state 暗黙的に受け取るstate
   * @param {Object} payload 引数の情報
   * @param {String} payload.type 画像のタイプ
   * @param {Object} payload.settingImage 画像の設定情報
   */
  setSettingImage: (state, payload) => {
    state.settingImages = Object.assign({}, state.settingImages, { [payload.type]: payload.settingImage })
  },
  /**
   * stateのリセット
   * @param {Object} state 暗黙的に受け取るstate
   */
  resetState: state => {
    state = Object.assign(state, getDefaultState())
  }
}

const actions = {
  /**
   * 指定タイプの最新の画像の設定情報を取得
   * @param {String} type 画像のタイプ
   */
  getSettingImage: async ({ commit }, type) => {
    try {
      const snapshot = await firestore
        .collection('setting_images')
        .where('type', '==', type)
        .orderBy('createdAt', 'desc')
        .limit(1)
        .get()

      snapshot.forEach(doc => {
        commit('setSettingImage', { type: type, settingImage: Object.assign(doc.data(), { siid: doc.id }) })
      })
    } catch {
      router.push({ name: 'error' })
    }
  },
  /**
   * 画像の設定情報を追加
   * @param {Object} params 引数
   */
  addSettingImage: async ({ commit }, params) => {
    try {
      const ref = await firestore.collection('setting_images').add(params)
      commit('setSettingImage', { type: params.type, settingImage: Object.assign(params, { siid: ref.id }) })
    } catch {
      router.push({ name: 'error' })
    }
  },
  /**
   * 画像の設定情報を更新
   * @param {Object} payload 引数
   * @param {String} payload.siid 画像の設定情報のID
   * @param {Object} payload.params 更新内容
   * @return {void}
   */
  updateSettingImage: async ({ commit }, payload) => {
    try {
      await firestore.collection('setting_images').doc(payload.siid).update(payload.params)

      commit('setSettingImage', { type: payload.params.type, settingImage: Object.assign(payload.params, { siid: payload.siid }) })
    } catch {
      router.push({ name: 'error' })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
